import { render, staticRenderFns } from "./ItemStatisticsForGame.vue?vue&type=template&id=683ab85a&scoped=true&"
import script from "./ItemStatisticsForGame.vue?vue&type=script&lang=js&"
export * from "./ItemStatisticsForGame.vue?vue&type=script&lang=js&"
import style0 from "./ItemStatisticsForGame.vue?vue&type=style&index=0&id=683ab85a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "683ab85a",
  null
  
)

export default component.exports